import React, { useState } from "react";
import { Box, Image } from 'native-base';
import { useNavigation } from '@react-navigation/native';
import Screen from "./Screen";
import SearchResultCard from "../cards/SearchResultCard";
import SearchResultList from "../search/SearchResultList";
import SearchBox from "../search/SearchBox";
import { useQuery } from "react-query";
import { searchWineries } from "../../services/winery/wineryApi";
import urls from "../../services/urls";

export default function Wineries() {
    const navigation = useNavigation();
    const [query, setQuery] = useState('');
    const { data: wineries } = useQuery(['/winery/search', query, 'searchWineries'], () => searchWineries(query));
    return (
        <Screen>
            <Image
                source={{ uri: urls.imageBase + '/pinceszetek.jpg'}}
                width="100%"
                height="40"
                resizeMode= "contain"
                alt=" "
                mt="5"
                mb="5"
            />
            <SearchBox space="5" query={query} setQuery={setQuery}/>
            {
                wineries?.length > 0
                ?
                <SearchResultList
                    data={wineries}
                    dataKey="id"
                    space={5}
                    renderItem={({item}) => <SearchResultCard {...item} onPress={() => navigation.push('Winery', {slug: item.slug})}/>}
                />
                :
                <Box p={25}/>
            }
        </Screen>
    );
}

